import React from 'react';
import  Class6Fieldtrip2024  from 'views/Class6Fieldtrip2024';


const VissionAndMissionPage = () => {
  return <Class6Fieldtrip2024/>;
};

export default VissionAndMissionPage;